module.exports = __webpack_public_path__ + "img/royalpay.7f8e31b8.png";